import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError as observableThrowError, Observable } from "rxjs";
import { CashRegisterProvisionSearchResponse } from '../../../models/rest/cash-register/cash-register-provision-search-response';
import { CashRegisterProvisionEntity } from '../../../models/entity/cash-register/cash-register-provision.entity';
import { CashRegisterProvisionSearchRequest } from '../../../models/rest/cash-register/cash-register-provision-search-request';
import { CashRegisterReconciliationRequest } from '../../../models/rest/cash-register/reconciliation/cash-register-reconciliation-request';
import { CashRegisterReconciliationResponse } from '../../../models/rest/cash-register/reconciliation/cash-register-reconciliation-response';
import { BaseRestService } from '../../../services/base-rest.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { CashRegisterCreateBasketResponse } from '../../../models/rest/cash-register/sale/cash-register-create-basket-response';
import { CashRegisterPaymentAddVendorRequest } from '../../../models/rest/cash-register/sale/cash-register-payment-add-vendor-request';
import { CashRegisterPaymentStartRequest } from '../../../models/rest/cash-register/sale/cash-register-payment-start-request';
import { CashRegisterPaymentStartResponse } from '../../../models/rest/cash-register/sale/cash-register-payment-start-response';
import { CashRegisterPaymentCancelLocalRequest } from '../../../models/rest/cash-register/cancel/cash-register-payment-cancel-local-request';
import { CashRegisterPaymentCancelLocalResponse } from '../../../models/rest/cash-register/cancel/cash-register-payment-cancel-local-response';
import { CashRegisterPaymentCancelVendorRequest } from '../../../models/rest/cash-register/cancel/cash-register-payment-cancel-vendor-request';
import { CashRegisterPaymentCancelVendorResponse } from '../../../models/rest/cash-register/cancel/cash-register-payment-cancel-vendor-response';
import { CashRegisterManualRefundRequest } from '../../../models/rest/cash-register/cash-register-manual-refund-request';
import { CashRegisterManualPaymentRequest } from '../../../models/rest/cash-register/cash-register-manual-payment-request';
import { CashRegisterQueryBasketStatusRequest } from '../../../models/rest/cash-register/cash-register-query-basket-status-request';
import { CashRegisterQueryBasketStatusResponse } from '../../../models/rest/cash-register/cash-register-query-basket-status-response';
import { ExportFileResponse } from '../../../models/rest/common/export-file-response';

@Injectable({
  providedIn: 'root'
})
export class CashRegisterProvisionService extends BaseRestService {
  constructor(protected httpClient: HttpClient, protected sessionStorageService: SessionStorageService) {
    super(httpClient, sessionStorageService);
  }

  getCashRegisterProvisions(): Observable<CashRegisterProvisionEntity[]> {
    const url = `/cash-register-provisions`;
    return this.httpGet<CashRegisterProvisionEntity[]>(url).pipe(catchError(this.errorHandler));
  }

  getAllBySearch(data): Observable<CashRegisterProvisionSearchResponse[]> {
    const url = `/cash-register-provisions/search`;
    return this.httpPost<CashRegisterProvisionSearchRequest>(url, data)
      .pipe(catchError(this.errorHandler));
  }
  getReconciliationReport(data: CashRegisterReconciliationRequest): Observable<CashRegisterReconciliationResponse> {
    const url = `/cash-register-provisions/reconciliation`;
    return this.httpPost<CashRegisterProvisionSearchRequest>(url, data)
      .pipe(catchError(this.errorHandler));
  }


  startCashRegisterPayment(search: CashRegisterPaymentStartRequest): Observable<CashRegisterPaymentStartResponse> {
    const url = `/cash-register-provisions/start-cash-register-payment`;
    return this.httpPost<CashRegisterPaymentStartResponse>(url, search).pipe(catchError(this.errorHandler));
  }


  createBasketForCashRegister(search: CashRegisterPaymentStartRequest): Observable<CashRegisterCreateBasketResponse> {
    const url = `/cash-register-provisions/create-cash-register-basket`;
    return this.httpPost<CashRegisterCreateBasketResponse>(url, search).pipe(catchError(this.errorHandler));
  }

  handleAddPaymentResponse(search: CashRegisterPaymentAddVendorRequest): Observable<CashRegisterPaymentStartResponse> {
    const url = `/cash-register-provisions/handle-cash-register-payment-response`;
    return this.httpPost<CashRegisterCreateBasketResponse>(url, search).pipe(catchError(this.errorHandler));
  }

  getCancelPaymentRequestLocal(search: CashRegisterPaymentCancelLocalRequest): Observable<CashRegisterPaymentCancelLocalResponse> {
    const url = `/cash-register-provisions/cancel-payment-request-local`;
    return this.httpPost<CashRegisterPaymentCancelLocalResponse>(url, search).pipe(catchError(this.errorHandler));
  }

  handleCancelPaymentVendorResponse(search: CashRegisterPaymentCancelVendorRequest): Observable<CashRegisterPaymentCancelVendorResponse> {
    const url = `/cash-register-provisions/handle-cancel-payment-response`;
    return this.httpPost<CashRegisterPaymentCancelVendorResponse>(url, search).pipe(catchError(this.errorHandler));
  }

  clearBasket(cashRegisterId: number): Observable<void> {
    const url = `/cash-registers/clear-basket`;
    return this.httpPost<void>(url, { cashRegisterId }).pipe(catchError(this.errorHandler));
  }

  getReceiptFile(id): Observable<ExportFileResponse> {
    const url = `/cash-register-provisions/${id}/receipt`;
    return this.httpGet<ExportFileResponse>(url).pipe(catchError(this.errorHandler));
  }

  manualRefundPayment(request: CashRegisterManualRefundRequest): Observable<void> {
    const url = `/cash-register-provisions/refund-manual`;
    return this.httpPost<void>(url, request).pipe(catchError(this.errorHandler));
  }

  manualPayment(request: CashRegisterManualPaymentRequest): Observable<any> {
    const url = `/cash-register-provisions/payment-manual`;
    return this.httpPost<any>(url, request).pipe(catchError(this.errorHandler));
  }

  queryBasketStatusAndApply(request: CashRegisterQueryBasketStatusRequest): Observable<CashRegisterQueryBasketStatusResponse> {
    const url = `/cash-register-provisions/query-basket-status-and-apply`;
    return this.httpPost<CashRegisterQueryBasketStatusResponse>(url, request).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    //
    // console.log(error);
    return observableThrowError(error);
  }
}
